import script from "./PostDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PostDetail.vue?vue&type=script&setup=true&lang=js"

import "./PostDetail.vue?vue&type=style&index=0&id=a3564564&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3564564"]])

export default __exports__